import { render } from "./padel-confirm-phone.template.html?vue&type=template&id=d4966978&scoped=true"
import script from "./PadelConfirmPhone.vue?vue&type=script&lang=ts"
export * from "./PadelConfirmPhone.vue?vue&type=script&lang=ts"

import "./PadelConfirmPhone.vue?vue&type=style&index=0&id=d4966978&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4966978"

export default script